import React, {FC} from 'react';
import {TextField} from "@mui/material";
import {observer} from "mobx-react";
import {useStorageUserListContext} from "@app/modules/SelfConfig/contexts/storage";
import {Checkbox} from "@mui/material";
import './UserPassword.scss'
import {Typography} from "@mui/material";
import {runInAction} from "mobx";
import {Stack} from "@mui/system";
import {CheckboxBase} from "@app/components/CheckboxBase/CheckboxBase";

type TProps = {
}

export const UserPassword: FC<TProps> = observer((props: TProps) => {

    const {usersListStore} = useStorageUserListContext();


    return (
        <Stack spacing={1}>
            <CheckboxBase
                description={"Change password"}
                value={usersListStore.wantsToChangePassword}
                checked={usersListStore.wantsToChangePassword}
                onChange={() => {
                    usersListStore.wantsToChangePassword = !usersListStore.wantsToChangePassword
                    if (usersListStore.wantsToChangePassword == false) {
                        usersListStore.userPassword = ''
                    }
                }}
            />

            <TextField
                disabled={!usersListStore.wantsToChangePassword}
                type={"password"}
                label={"Password"}
                name={"user-password"}
                autoComplete="off"
                onChange={(e) => {
                    runInAction(() => {
                        usersListStore.wantsToChangePassword == true ? usersListStore.userPassword = (e.target.value) : ''
                    })
                }}
                value={usersListStore.userPassword}
            />
        </Stack>
    )

})



